import userReducer, { setUser, getUser } from './userSlicer';

export { setUser, getUser };
export default userReducer;
